import { runOwsRequestWithMonitor, Feature } from '../../../../shared';
import { DeletePersonasRequest, getServiceAsync } from '../../../../service';

export function deletePersonas(
    personaIds: string[],
    additionalLogProperties?: {}
): Promise<boolean> {
    return getServiceAsync().then(service => {
        const request: DeletePersonasRequest = service.Factory.deletePersonasRequest({
            ItemIds: personaIds.map(personaId => {
                return service.Factory.itemId({ Id: personaId });
            }),
        });

        return runOwsRequestWithMonitor({
            scenarioName: 'DeletePersonas',
            feature: Feature.ContactManagement,
            operation: () =>
                service.Operation.deletePersonasOperation({
                    request: request,
                }),
            qoSConfig: additionalLogProperties && {
                additionalQoSLogProperty: additionalLogProperties,
            },
            transformResponse: (response: boolean) => response,
        });
    });
}
